import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getAll(data) {
        let params = "";
        if (data) {
            Object.keys(data).forEach(key => {
                params += `${key}=${data[key]}&`;
            });
        }
        return api.get(`/api/v1/job-title?${params}`);
    },
    getById(id) {
        return api.get(`/api/v1/job-title/${id}`);
    },
    update(data) {
        return api.put(`/api/v1/job-title/${data.id}`, data);
    },
    create(data) {
        return api.post(`/api/v1/job-title`, data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    },
    delete(id) {
        return api.delete(`/api/v1/job-title/${id}`);
    },
}